<div>
  <label>Sign Up Page Enabled</label>
  <span>{{product.onboarding.sign_up_page.enabled === 'true' ? "Enabled" : "Disabled"}}</span>
  <hr />
</div>

@if (product.onboarding.sign_up_page.message_text) {
  <div>
    <label>Message text</label>
    <span>{{product.onboarding.sign_up_page.message_text}}</span>
    <hr />
  </div>
}

@if (product.onboarding.sign_up_page.consent_type) {
  <div>
    <label>Consent type</label>
    <span>{{product.onboarding.sign_up_page.consent_type}}</span>
    <hr />
  </div>
}

@if (product.onboarding.sign_up_page.failure_text) {
  <div>
    <label>Submit button label</label>
    <span>{{product.onboarding.sign_up_page.failure_text}}</span>
    <hr />
  </div>
}

<div>
  <label>Success copy</label>
  <span>{{product.onboarding.sign_up_page.success_text}}</span>
  <hr />
</div>

<div>
  <label>Failure copy</label>
  <span>{{product.onboarding.sign_up_page.failure_text}}</span>
  <hr />
</div>

<div>
  <label>Validation fields</label>
  <span>
    <p>
      {{product.onboarding.sign_up_page.ccid_input_label}}
    </p>
    <p>
      Mobile Number
    </p>
    @for (field of client.validation.fields; track field) {
      <p>
        {{field.prompt}}
      </p>
    }
  </span>
  <hr />
</div>
